import { ApplicationInsights } from "@microsoft/applicationinsights-web";
import { APP_ENVIRONMENT, APP_VERSION } from "../config";
import { getRuntimeConfig } from "../runtimeConfig";

let appInsightsInstance = null;
let listenersRegistered = false;

function normalizeError(input) {
  if (input instanceof Error) return input;
  if (typeof input === "string") return new Error(input);
  try {
    return new Error(JSON.stringify(input));
  } catch (e) {
    return new Error("Unknown frontend error");
  }
}

export function reportFrontendError(error, properties = {}) {
  if (!appInsightsInstance) return;
  appInsightsInstance.trackException({
    exception: normalizeError(error),
    properties,
  });
}

function registerGlobalErrorHandlers() {
  if (listenersRegistered || typeof window === "undefined") return;

  window.addEventListener("error", (event) => {
    reportFrontendError(event.error || event.message, {
      source: "window.error",
      filename: event.filename,
      line: event.lineno,
      column: event.colno,
    });
  });

  window.addEventListener("unhandledrejection", (event) => {
    reportFrontendError(event.reason, {
      source: "window.unhandledrejection",
    });
  });

  listenersRegistered = true;
}

export function initializeAppInsights() {
  if (appInsightsInstance) return appInsightsInstance;

  const connectionString = getRuntimeConfig().appInsights.connectionString;
  const appVersion = APP_VERSION || "unknown";
  const normalizedEnvironment = (APP_ENVIRONMENT || "").toUpperCase();
  if (normalizedEnvironment === "DEV" || normalizedEnvironment === "UAT") {
    console.log("APPINSIGHTS_CONNECTION_STRING:", connectionString || "");
    console.log("APP_VERSION:", appVersion);
  }

  if (!connectionString) return null;

  appInsightsInstance = new ApplicationInsights({
    config: {
      connectionString,
      enableAutoRouteTracking: true,
    },
  });

  appInsightsInstance.loadAppInsights();
  appInsightsInstance.addTelemetryInitializer((envelope) => {
    envelope.tags = envelope.tags || {};
    envelope.tags["ai.application.ver"] = APP_VERSION;
    envelope.data = envelope.data || {};
    envelope.data.APP_ENVIRONMENT = normalizedEnvironment;
  });
  registerGlobalErrorHandlers();
  return appInsightsInstance;
}

export function getTelemetryContext() {
  if (!appInsightsInstance) {
    return { appInsightsSessionId: "", appInsightsTraceId: "" };
  }
  return {
    appInsightsSessionId: appInsightsInstance.context?.session?.id || "",
    appInsightsTraceId: appInsightsInstance.context?.telemetryTrace?.traceID || "",
  };
}
